import styled from 'styled-components'
import Caption1 from '../typography/captions/Caption1'
import ErrorText from '../typography/ErrorText'

const HelperText = styled(Caption1)`
  margin-top: 4px;
`

const ButtonErrorText = styled(ErrorText)`
  position: absolute;
  left: 0;
  bottom: 0;
`

export { HelperText, ButtonErrorText }



// WEBPACK FOOTER //
// ./src/components/quest/_Styled.js